module.exports = __webpack_public_path__ + "assets/img/LogOut@2x.b41c8b29.png";